import { IHttpParamSerializer, IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import {
  ITableCandidateData,
  ITableCandidatesRes,
  TableCandidate
} from './../candidate/table-candidate';
import { ApiService } from '../api-service/api.service';

export class ApplicantService {
  static $inject = ['ApiService', '$http', 'GmcApi', '$httpParamSerializer'];

  constructor(
    private apiService: ApiService,
    private $http: IHttpService,
    private gmcApi: GmcApi,
    private $httpParamSerializer: IHttpParamSerializer
  ) {}

  getApplicants(
    _vacancyId,
    params: object = {}
  ): IPromise<ITableCandidateData> {
    return this.apiService
      .post<ITableCandidatesRes>(
        '/applicants/' + _vacancyId,
        this.$httpParamSerializer(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        return {
          count: res.count || 0,
          pages: res.pages || 0,
          candidates: res.data.map((item) => new TableCandidate(item))
        };
      });
  }

  addApplicant(_vacancyId: string): IPromise<any> {
    return this.apiService
      .post<any>('/applicants/' + _vacancyId, {})
      .then((res) => {
        console.log('addApplicant(' + _vacancyId + ') resp: ', res);
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  removeApplicant(_vacancyId: string, _candidateId: string): IPromise<any> {
    return this.apiService
      .delete<any>('/applicants/' + _vacancyId + '/' + _candidateId)
      .then((res) => {
        console.log(
          'removeApplicant(' + _vacancyId + ', ' + _candidateId + ') resp: ',
          res
        );
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.error : 'Error');
      });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/applicant/applicant.service.ts